import { MabArticleModel } from '@app/platform/articles/pages/mab-articles/models/mab-article.model';
import { createAction, props } from '@ngrx/store';
import { ErrorModel } from '@shared-lib/models/error.model';

export const getArticlesAction = createAction('[ARTICLES] Get Smart Searches');
export const getArticlesActionSuccess = createAction('[ARTICLES] Get Smart Searches Success', props<{ data: MabArticleModel[] }>());
export const getArticlesActionFailure = createAction('[ARTICLES] Get Smart Searches Failure', props<{ error: ErrorModel }>());
